module.exports = __webpack_public_path__ + "img/flow-demo.efdfe8bd.png";